import imageUrlBuilder from '@sanity/image-url'
import {useMemo} from 'react'
import useShopConfig from '~/hooks/useShopConfig'

const useImageBuilder = () => {
    const {cms} = useShopConfig()
    return useMemo(() => imageUrlBuilder(cms), [cms])
}

export default useImageBuilder
